// libs
import React from 'react';

// components
import { Typography } from '@lyearn/ui';

// content
import { useProviderContent } from '../context';
// types
import { LabelProps } from '../types';

function Label({ variant = 'body-short-01', color = 'text-text-primary', className }: LabelProps) {
  const { provider } = useProviderContent();

  if (!provider?.name) {
    return null;
  }

  return (
    <Typography className={className} color={color} variant={variant}>
      {provider.name}
    </Typography>
  );
}

export default React.memo(Label);
